// src/admin/pages/AdminSecurity.jsx
import React, { useEffect, useState } from "react";
import { createAdminUser, listAdminUsers, updateAdminStatus } from "../../api/adminUsersApi";

export default function AdminSecurity() {
  const [items, setItems] = useState([]);
  const [busy, setBusy] = useState(true);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");

  const load = async () => {
    setBusy(true);
    try {
      setItems(await listAdminUsers());
    } finally {
      setBusy(false);
    }
  }; 

  useEffect(() => { load(); }, []);

  const create = async () => {
    if (!name || !email || !password) return alert("Name, email, password required");
    await createAdminUser({ name, email, phone, password, role: "SUPER_ADMIN" });
    setName(""); setEmail(""); setPhone(""); setPassword("");
    await load();
  };

  const toggle = async (u) => {
    const next = u.status === "ACTIVE" ? "DISABLED" : "ACTIVE";
    const reason = prompt(`Reason to set ${u.email} => ${next}?`) || "";
    await updateAdminStatus(u.id, next, reason);
    await load();
  };

  return (
    <div>
      <h2 className="text-2xl font-extrabold tracking-tight">Security</h2>
      <p className="mt-2 text-sm text-slate-600">
        Create admins and enable/disable them. (Roles/permissions will be added next.)
      </p>

      <div className="mt-6 grid gap-6 lg:grid-cols-2">
        <div className="rounded-2xl border border-slate-200 p-5">
          <div className="font-extrabold">Create Admin</div>

          <div className="mt-4 space-y-3">
            <input className="w-full rounded-xl border border-slate-200 px-3 py-2"
              placeholder="Name" value={name} onChange={(e)=>setName(e.target.value)} />
            <input className="w-full rounded-xl border border-slate-200 px-3 py-2"
              placeholder="Email" value={email} onChange={(e)=>setEmail(e.target.value)} />
            <input className="w-full rounded-xl border border-slate-200 px-3 py-2"
              placeholder="Phone (optional)" value={phone} onChange={(e)=>setPhone(e.target.value)} />
            <input className="w-full rounded-xl border border-slate-200 px-3 py-2"
              placeholder="Password" value={password} onChange={(e)=>setPassword(e.target.value)} />
            <button
              onClick={create}
              className="rounded-xl bg-slate-900 text-white font-extrabold px-4 py-2.5 hover:opacity-95"
            >
              Create
            </button>
          </div>
        </div>

        <div className="rounded-2xl border border-slate-200 p-5">
          <div className="font-extrabold">Admin Users</div>

          {busy ? (
            <div className="mt-3 text-sm text-slate-600">Loading…</div>
          ) : (
            <div className="mt-4 space-y-2">
              {items.map((u) => (
                <div key={u.id} className="rounded-xl border border-slate-200 px-4 py-3 flex items-center justify-between">
                  <div>
                    <div className="font-bold">{u.name}</div>
                    <div className="text-xs text-slate-600">{u.email} • {u.role} • {u.status}</div>
                  </div>

                  <button
                    onClick={() => toggle(u)}
                    className="rounded-xl border border-slate-200 px-3 py-2 text-sm font-semibold hover:bg-slate-50"
                  >
                    {u.status === "ACTIVE" ? "Disable" : "Enable"}
                  </button>
                </div>
              ))}
              {!items.length ? <div className="text-sm text-slate-600">No admins.</div> : null}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
